<template>
  <div class="researchEducation">
    <template v-if="!isIndex">
      <el-tabs
        :tab-position="tabPosition"
        :value="activateName"
        style="height: auto"
        @tab-click="handleTabClick"
      >
        <el-tab-pane 
          v-for="year in showYearsList" 
          :key="year"
          :label="year" 
          :name="year" 
          :v-if="showYearTabs[year]"
        >
          <div
            class="actSlider-box"
            v-for="item in publicActivities[year]"
            :key="item.id"
          >
            <ActSlider
              class="actSlider-component"
              :showData="item"
              :showNumber="item.id"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </template>
    <template v-else>
      <div class="publicActWap">
        <div class="wap-act-tab">
          <div
            class="wap-tab"
            v-for="item in showYearsList"
            :key="item"
            @click="actTap(item)"
            :class="{ actTap: curIndex == item }"
          >
            {{ item }}
          </div>
        </div>
        <div class="actSlider-box" v-for="item in activity" :key="item.id">
          <ActSlider
            class="actSlider-component"
            :showData="item"
            :showNumber="item.id"
          />
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import ActSlider from "../components/actSlider";
export default {
  name: "publicActivities",
  components: {
    ActSlider,
  },
  data() {
    return {
      isIndex: false,
      tabPosition: "left",
      activateName: "2025",
      lan: this.$store.state.isEn,
      publicActivities: {}, // 使用对象存储各年份的数据
      showYearsList: [],
      activity: {},
      curIndex: 2025,
      showYears: 2025,
      showYearTabs: {}, // 动态控制年份标签显示
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },

  created() {
    // 获取当前屏幕宽度
    let screenWidth = window.innerWidth || document.documentElement.clientWidth;
    if (screenWidth < 961) {
      this.isIndex = true;
    }
    // 创建一个媒体查询，检查屏幕的宽度是否大于或等于 768px
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    // 添加事件侦听器，在状态更改时收到通知
    this.mediaQuery.addListener(this.handleMediaQueryChange);
    this.init();
  },
  beforeDestroy() {
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
  },
  methods: {
    handleMediaQueryChange(event) {
      let screenWidth =
        window.innerWidth || document.documentElement.clientWidth;
      if (event.matches) {
        this.isIndex = false;
      } else {
        this.isIndex = true;
        this.screenWidth = screenWidth;
      }
    },
    handleTabClick(tab) {
      // 处理标签页点击事件
      this.activateName = tab.name;
    },
    async actTap(ev) {
      this.curIndex = ev;
      await this.$api.get(
        "/activity/list",
        { current: 1, pageSize: 10, activityType: 5, activityYear: ev },
        (res) => {
          const { data, code } = res;
          if (code == 0) {
            data.forEach((el) => {
              if (el.image) {
                el.showImg = JSON.parse(el.image);
              }
            });
            this.activity = data;
          }
        }
      );
    },
    async init() {
      let actYear = 2023;
      this.showYears = new Date().getFullYear();
      
      // 存储所有有数据的年份
      const yearsWithData = [];
      
      // 使用 Promise.all 等待所有 API 请求完成
      const requests = [];
      
      for (let index = 0; index <= this.showYears - 2023; index++) {
        actYear = 2023 + index;
        let yearTip = JSON.stringify(actYear);
        
        // 创建一个 Promise 来包装 API 调用
        const requestPromise = new Promise((resolve) => {
          this.$api.get(
            "/activity/list",
            { current: 1, pageSize: 10, activityType: 5, activityYear: actYear },
            (r) => {
              const { data = [], code } = r;
              if (code == 0) {
                if (data && data.length > 0) {
                  data.forEach((el) => {
                    if (this.lan) {
                      el.showImg = el.image && JSON.parse(el.image);
                    } else {
                      el.showImg = el.image && JSON.parse(el.image);
                    }
                  });
                  
                  // 将数据存储到对应年份的对象中
                  if (!this.publicActivities) {
                    this.publicActivities = {};
                  }
                  this.publicActivities[Number(yearTip)] = data;
                  
                  // 设置对应年份的标签为显示状态
                  this.$set(this.showYearTabs, Number(yearTip), true);
                  
                  yearsWithData.push(Number(yearTip)); // 添加到有数据的年份列表
                  
                  this.showYearsList.push(yearTip); // 使用 push 而不是 unshift
                }
              }
              resolve(); // 完成后解析 Promise
            }
          );
        });
        
        requests.push(requestPromise);
      }
      
      // 等待所有请求完成
      await Promise.all(requests);

      // 对年份列表进行从大到小排序
      this.showYearsList.sort((a, b) => Number(b) - Number(a));
      
      // 设置默认激活的标签为最大年份
      if (this.showYearsList.length > 0) {
        const maxYear = this.showYearsList[0];
        this.activateName = String(maxYear);
        this.curIndex = Number(maxYear);
        this.actTap(String(maxYear));
      }
    },
  },
};
</script>
<style scoped>
.researchEducation {
  width: 1440px;
  margin: 154px auto 100px;
}
/* 去掉tabs标签栏下的下划线 */
::v-deep .el-tabs__nav-wrap::after {
  position: static !important;
  /* background-color: #fff; */
}
/* 下划线切换高亮 */
::v-deep .el-tabs__active-bar {
  background-color: transparent;
}
/* 鼠标选中时样式 */
::v-deep .el-tabs__item.is-active {
  color: #ca9d76;
  opacity: 1;
}
/* 鼠标悬浮时样式 */
::v-deep .el-tabs__item:hover {
  cursor: pointer;
  opacity: 1;
  color: #ca9d76;
}
::v-deep .el-tabs__item {
  font-family: SourceHanSansCN-Bold;
  font-size: 28px;
  color: #98989f;
  font-weight: 600;
  margin-bottom: 24px;
}
.actSlider-box {
  width: 100%;
  margin-left: 90px;
}
.actSlider-component {
  margin-bottom: 80px;
}
@media (max-width: 1440px) {
  .researchEducation {
    max-width: 100%;
    margin: 130px auto 60px;
  }
  .actSlider-component {
    margin-bottom: 80px;
  }
  .actSlider-box {
    margin-left: 20px;
  }
  ::v-deep .el-tabs {
    max-width: 90%;
    margin: 0 auto;
  }
}
@media (max-width: 960px) {
  .researchEducation {
    width: 100%;
    margin: 100px auto 30px;
  }
  .wap-act-tab {
    display: flex;
    margin: 0px auto;
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
  }
  .wap-tab {
    margin: 10px;
    border: 2px solid rgba(102, 102, 102, 1);
    border-radius: 4px;
    width: 130px;
    height: 48px;
    line-height: 45px;
    text-align: center;
    color: #000;
    font-size: 16px;
  }
  .actSlider-component {
    margin-bottom: 40px;
  }
  .actTap {
    background-color: #000;
    color: #fff;
  }
  .actSlider-box {
    width: 95%;
    margin-left: 20px;
  }
}
@media (max-width: 768px) {
  .wap-tab {
    margin: 0 10px 20px;
    border: 1px solid rgba(102, 102, 102, 1);
    border-radius: 4px;
    width: 80px;
    height: 30px;
    line-height: 28px;
    text-align: center;
    color: #000;
    font-size: 13px;
  }
  .actTap {
    background-color: #000;
    color: #fff;
  }
}
</style>